export {
  getOrganisationsFromAccessToken,
  getUser,
  getUserManager,
  getUserProfileInfo,
  storeAuthProvider,
  storeCognitoAuthMode,
  getSessionHeaders,
  type AuthProvider,
} from "shell/platform/lib/oidcClient";
export {
  completeNewPasswordChallenge,
  confirmPasswordReset,
  refreshCognitoTokens,
  requestPasswordReset,
  signInWithPassword,
} from "shell/platform/lib/cognitoPasswordAuth";
export { setPostLoginRedirect } from "shell/platform/lib/authRedirect";

import {
  restFetch as restFetchImpl,
  unauthenticatedRestFetch as unauthenticatedRestFetchImpl,
} from "shell/platform/lib/restClient";

// orval's mutator introspection (see orval.config.ts) statically parses this
// file to detect the fetcher's second parameter, so these must be real
// function declarations rather than bare `export { ... } from ...` re-exports,
// which it can't see through.
export const restFetch = <T>(url: string, init: RequestInit = {}): Promise<T> =>
  restFetchImpl<T>(url, init);

export const unauthenticatedRestFetch = <T>(
  url: string,
  init: RequestInit = {},
): Promise<T> => unauthenticatedRestFetchImpl<T>(url, init);
